import api from './api';

const contactService = {
  // Send contact form message
  sendMessage: async (contactData) => {
    try {
      const response = await api.post('/contact/send', contactData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to send message' };
    }
  },

  // Test email configuration (for debugging)
  testEmail: async () => {
    try {
      const response = await api.post('/contact/test');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Test email failed' };
    }
  }
};

export default contactService;
